import { Modal, Tab } from '@scuf/common';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'styles/main.scss';
import 'styles/repaircenter.scss';
import 'styles/spareParts.scss';
import SparePartsReport from './components/tabs/sparePartsReport';
import SparePartsSearch from './components/tabs/sparePartsSearch';
import { SparePartsAdminChat } from './components/tabs';
import useUser from 'helpers/hooks/useUser';
import useFetch from 'helpers/hooks/useFetch';
import { SparePartsChatTable } from 'models/repaircenter/detailsRma';
import { SPARE_PARTS, USER_MANAGER } from 'resources';
import { useRecoilState } from 'recoil';
import { ChatSpareParts } from 'resources/atoms/spareParts';
import usePreventClickjacking from 'helpers/hooks/usePreventingClickjacking';
import ImageManagement from './components/tabs/ImageManagement';

const SUPERADMIN = '1';
const ADMIN = '2';

interface ManualFile {
    id: number;
    displayName: string;
    storedFileName: string;
    section: "SPAREPARTS";
}

function SpareParts() {

    const { user } = useUser();
    const { t } = useTranslation(['spareparts', 'common']);
    const [ChatsSpareParts, setChatsSpareParts] = useRecoilState<SparePartsChatTable[]>(ChatSpareParts);
    const [unreadMessage, setUnreadMessage] = useState<number>(0);
    const [chats, loadChats] = useFetch<{ roleId: number; ssoId: string; companyId: number }, SparePartsChatTable[]>({
        url: SPARE_PARTS.getAllChats
    });

    const [show, setShow] = useState(false);
    const { user: userDetails, getUser } = useUser();
    const [fileUrl, setFileUrl] = useState<string>();
    const [, fetchFiles] = useFetch<void, ManualFile[]>({
        url: `${USER_MANAGER.getManualFilesBySection}?section=SPAREPARTS`,
        method: 'GET',
    });

    useEffect(() => {
        if (userDetails && Object.keys(userDetails).length > 0) {
            loadFiles();
        }
    }, [userDetails]);


    const loadFiles = async (): Promise<void> => {
        try {
            await fetchFiles(undefined, (resp) => {
                const checkList: ManualFile[] = resp?.data ?? [];
                if (checkList.length > 0) {
                    const foundFile = checkList.find(file => file.displayName === 'mensagemspare');
                    if (foundFile) {
                        const url = `${USER_MANAGER.downloadManualFileById}?id=${foundFile.id}`;
                        setFileUrl(url);
                        setShow(true);
                    }
                }
            });
        } catch (error: any) {
            if (error.status === 401) {
                await getUser();
            } else {
                console.error(t('manual.fetchFilesError'));
            }
        }
    };

    useEffect(() => {
        UnreadMessage();
        setChatsSpareParts(chats?.data?.map((e: SparePartsChatTable) => ({ ...e, order: 'teste' }))!);
    }, [chats]);

    useEffect(() => {
        loadChats({ roleId: parseInt(user?.role!), ssoId: user?.ssoid!, companyId: user?.company! });
        setChatsSpareParts(chats?.data?.map((e: SparePartsChatTable) => ({ ...e }))!);
        UnreadMessage();
    }, []);

    const UnreadMessage = () => {
        chats?.data?.forEach(e => {
            if (user?.role === '1' || user?.role === '2') {
                if (e.itWasReadByAdmin === false) {
                    setUnreadMessage(unreadMessage => unreadMessage + 1);
                }
            } else if (user?.role === '3' || user?.role === '4') {
                if (e.itWasReadByCustomer === false) {
                    setUnreadMessage(messageRead => messageRead + 1);
                }
            }
        });
    };

    return (
        <>
            {show && userDetails && Object.keys(userDetails).length > 0 && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}
                    onClick={() => setShow(false)}
                >
                    <img
                        style={{ maxWidth: '500px', maxHeight: '500px' }}
                        src={fileUrl}
                        onClick={(e) => e.stopPropagation()}
                        title="Mensagem Portal"
                    />
                </div>
            )}
            <div className="container wrap-content">
                <Tab defaultActiveIndex={0} className="tab-with-divider">
                    <Tab.Pane title={t('page_name')}>
                        <SparePartsSearch />
                    </Tab.Pane>
                    <Tab.Pane title={t('tabs.Report')}>
                        <SparePartsReport />
                    </Tab.Pane>
                    <Tab.Pane title={t('common:tabs.Chat')} badge={unreadMessage}>
                        <SparePartsAdminChat />
                    </Tab.Pane>
                    {user?.role === SUPERADMIN || user?.role === ADMIN ? (
                        <Tab.Pane title={t('common:tabs.ImageManagement')}>
                            <ImageManagement />
                        </Tab.Pane>
                    ) : (
                        []
                    )}
                </Tab>
            </div>
        </>
    );
}

export default SpareParts;
